module.exports = __webpack_public_path__ + "img/aupair-options.f0666858.svg";